import { Component, ElementRef, ViewChild } from '@angular/core';
import { AgEditorComponent } from 'ag-grid-angular';
/*import { IAfterGuiAttachedParams, ICellEditor, ICellEditorParams, GridApi } from "@ag-grid-enterprise/all-modules";*/
import { IAfterGuiAttachedParams, ICellEditor, ICellEditorParams, GridApi } from 'ag-grid-community';


@Component({
    selector: 'app-checkbox-editor',
    templateUrl: './checkbox-editor.component.html',
    styleUrls: ['./checkbox-editor.component.scss'],
    standalone: false
})
export class CheckboxEditorComponent implements AgEditorComponent, ICellEditor {

    @ViewChild('checkboxInput', { static: false }) private checkboxInputRef: ElementRef;

    api: GridApi;
    params: CheckboxEditorParams;

    get isChecked(): boolean {
        if (this.params == null) return false;
        return this.params.data[this.params.field] != null ? this.params.data[this.params.field] : false;
    }

    get isVisible(): boolean {
        if (this.params == null || this.params.isVisible == null) return true;
        return this.params.isVisible(this.params);
    }

    constructor() {
        
    }

    getValue() {
        return this.isChecked;
    }

    isPopup(): boolean { return false; }

    afterGuiAttached(params?: IAfterGuiAttachedParams): void {
        this.checkboxInputRef?.nativeElement?.focus();
    }

    onKeyDown(event: KeyboardEvent): void {
        if (event.key === ' ') {
            event.preventDefault();
            this.onClick();
        }
    }

    onClick(): void {
        this.params.data[this.params.field] = !this.isChecked;
        this.params.action(this.params.data);
    }

    agInit(params: CheckboxEditorParams): void {
        this.params = params;
        this.api = params.api;
    }
}


export interface CheckboxEditorParams extends ICellEditorParams {
    isVisible: any;
    action: any;
    field: string;
    description: string;
}